module.exports = __webpack_public_path__ + "assets/367412b32b9a1f7fc5effdb573d49ecb.mp3";